import {PREFERENCE_VARIABLE, PREFERENCE_WORD} from '@im-js/token/preference';
// @ts-nocheck
import type {PreferenceVariableService} from '@im-ng/preference/variable';
// @ts-nocheck
import type {PreferenceWordService} from '@im-ng/preference/word';

/**
 * 환경변수 서비스 식별
 * @see PREFERENCE_VARIABLE
 * @example
 * ```ts
 * const _core = inject(DotCoreService);
 * if(_core.includes(PREFERENCE_VARIABLE_SERVICE)){
 * 	const _variable = _core.inject(PREFERENCE_VARIABLE_SERVICE);
 * }
 * ```
 */
export const PREFERENCE_VARIABLE_SERVICE = PREFERENCE_VARIABLE.child<PreferenceVariableService>('PreferenceVariableService');

/**
 * 구성 단어 서비스 식별
 * @see PREFERENCE_WORD
 * @example
 * ```ts
 * const _core = inject(DotCoreService);
 * if(_core.includes(PREFERENCE_WORD_SERVICE)){
 * 	const _word = _core.inject(PREFERENCE_WORD_SERVICE);
 * }
 * ```
 */
export const PREFERENCE_WORD_SERVICE = PREFERENCE_WORD.child<PreferenceWordService>('PreferenceWordService');